import { useNavigate } from 'react-router-dom'
import useSurvey from '@survey/context/useSurvey'
import Button from '@mui/material/Button'
import ArrowForward from '@mui/icons-material/ArrowForward'
import { PageProps } from '@config/typing'
import providerStartSurveyConfigContent from '@config/provider/survey-intro.json'
import patientStartSurveyConfigContent from '@config/patient/survey-intro.json'
import StaticPage from '@common/StaticPage'
import { useRoot } from '@survey/context/RoleProvider'
import { PROVIDERS } from '../../../route.const'
import { useEffect } from 'react'
import useHeaderDetails from '@header/useHeaderDetails'
import useAdobeAnalytics from '@analytics/adobe'

const providerStartSurveyConfig =
  providerStartSurveyConfigContent.data as PageProps
const patientStartSurveyConfig =
  patientStartSurveyConfigContent.data as PageProps

const StartSurvey = () => {
  const navigate = useNavigate()
  const { surveyState } = useSurvey()
  const { startSectionId } = surveyState
  const { role } = useRoot()
  const { left, right } =
    role === PROVIDERS ? providerStartSurveyConfig : patientStartSurveyConfig
  const { login } = useHeaderDetails()
  const { trackLink } = useAdobeAnalytics()

  useEffect(() => {
    if (role === PROVIDERS && startSectionId) {
      navigate(startSectionId)
    }
  })

  return (
    <StaticPage
      left={left}
      right={right}
      action={
        <>
          {left.value.navigate.map((nav, index) => (
            <Button
              key={index}
              variant={'contained'}
              color={'primary'}
              endIcon={<ArrowForward />}
              onClick={() => {
                navigate(startSectionId)
                trackLink(
                  {
                    name: nav.text,
                    location: 'Main Content',
                    type: 'internal',
                  },
                  {
                    loginStatus: login ? 'logged in' : 'logged out',
                    userType: role,
                  }
                )
              }}
            >
              {nav.text}
            </Button>
          ))}
        </>
      }
      split={{ xs: 12, sm: 12, md: 12, lg: 6, xl: 6 }}
    />
  )
}

export default StartSurvey
